import '../../node_modules/slim-select/dist/slimselect.css'
import SlimSelect, {Config} from "slim-select";
import {$, $$} from "./Dom.ts";

/**
 * Méthode d'initialisation des selects avec SlimSelect
 * @param container Document | HTMLElement conteneur qui contient les selects à initialiser, pratique pour initialiser les selects recu en ajax,
 * attention au multiple initialisation, preciser bien le conteneur si c'est une initialisation en ajax
 */
export const initSelects = (container: Document | HTMLElement | string | null = document) => {
    if (container === null) return
    let parent: HTMLElement | Document
    if (typeof container === 'string') parent = $<HTMLElement>(container)!
    else parent = container

    // initChainedSelect(parent)

    $$<HTMLSelectElement>('select:not([data-js])', parent).forEach(select => {
        if (!select?.dataset?.manual) {
            createSimpleSelect(select)
        }
    })
}

export const createSimpleSelect = (selector: string | HTMLSelectElement): SlimSelect => {
    return new SlimSelect({
        select: selector,
        settings: {
            maxValuesShown: 9999,
            placeholderText: 'Sélectionner une option',
        }
    })
}

export const createComplexSelect = (config: Config): SlimSelect => {
    return new SlimSelect(config)
}

export const getMultipleValues = (id: string) => {
    return Array.from($$<HTMLOptionElement>(`#${id} option:checked`)).map(item => item.value)
}

export const selectMultipleValues = (id: string, values: string[]) => {
    values.forEach(value => {
        if (!id.startsWith('#')) {
            id = `#${id}`
        }
        const option = $<HTMLOptionElement>(`${id} option[value="${value}"]`)
        if (option) {
            option.selected = true
            option.setAttribute('selected', 'selected')
        }
    })
}

export const selectValue = (id: string, value: string) => {
    selectMultipleValues(id, [value])
}